export const breakpoints = {
  xSmall: '@media only screen and (max-device-width : 653px)',
  small: '@media only screen and (max-device-width : 767px)',
  medium: '@media (min-device-width: 768px)and (max-device-width: 1280px)',
};
